import { ref } from 'vue';

type Callback = () => void;

const callbacks = ref<Callback[]>([]);
export const useEscalateLogin = () => {
  const register = (callback: Callback) => {
    if (!callbacks.value.includes(callback)) {
      callbacks.value.push(callback);
    }
  };
  const unregister = (callback: Callback) => {
    const index = callbacks.value.findIndex((cb) => cb === callback);
    if (index > -1) {
      callbacks.value.splice(index, 1);
    }
  };
  const requestEscalatedLogin = () => {
    callbacks.value.forEach((callback) => callback());
  };

  return {
    requestEscalatedLogin,
    register,
    unregister,
  };
};
